export const companyInfo = {
  name: "KC Detailer",
  phone: "36 21 52 71",
  email: "KCdetail@Outlook.dk",
  address: "Trønninge by nr. 5 4420 Regstrup",
  openingHours: "Man-Fre: 08:00 - 17:00",
  googleRating: "4.9",
  reviewCount: "150+",
};

export const benefits = [
  {
    title: "Mindre arbejde i hverdagen",
    description: "Bilen bliver langsommere beskidt, og meget af snavset kan skylles af med rent vand. Det betyder mindre besvær og kortere tid på vask.",
    icon: "Clock",
  },
  {
    title: "En bil der ser bedre ud – hele tiden",
    description: "Få mere glans og dybde i lakken med et 'nypoleret look' i årevis. Din bil vil altid føles nyere og mere velholdt.",
    icon: "Sparkles",
  },
  {
    title: "Beskyttelse mod elementerne",
    description: "Effektiv beskyttelse mod UV-stråler, vejsalt, fugleklatter og kemikalier, der ellers ville nedbryde lakken.",
    icon: "ShieldCheck",
  },
  {
    title: "Bedre gensalgsværdi",
    description: "En velholdt lak gør bilen markant mere attraktiv ved salg og mindsker behovet for dyr klargøring inden salg.",
    icon: "TrendingUp",
  },
  {
    title: "Langtidsholdbar løsning",
    description: "I modsætning til voks holder keramisk coating i flere år. Det betyder færre udgifter og mindre vedligehold på sigt.",
    icon: "Calendar",
  },
  {
    title: "Ro i maven",
    description: "Du ved, at din bils vigtigste aktiv – lakken – er optimalt beskyttet mod hverdagens småting og slid.",
    icon: "Heart",
  },
];

export const pricingPackages = [
  {
    name: "Lille Bil",
    size: "Micro / Hatchback",
    examples: "VW Up, Hyundai i10, Ford Fiesta",
    price: "3.995",
    features: [
      "Grundig vask & Clay-behandling",
      "Let polering (Glansoptimering)",
      "Premium Keramisk Coating (3 års holdbarhed)",
      "Rens af fælge & dækpleje",
      "Ruder pudset udvendigt",
    ],
    popular: false,
  },
  {
    name: "Mellem Bil",
    size: "Sedan / Stationcar",
    examples: "Tesla Model 3, VW Passat, Audi A4",
    price: "4.995",
    features: [
      "Grundig vask & Clay-behandling",
      "Let polering (Glansoptimering)",
      "Premium Keramisk Coating (3 års holdbarhed)",
      "Rens af fælge & dækpleje",
      "Ruder pudset udvendigt",
    ],
    popular: true,
  },
  {
    name: "Stor Bil / SUV",
    size: "Stor SUV / MPV",
    examples: "Tesla Model X, Volvo XC90, Audi Q7",
    price: "5.995",
    features: [
      "Grundig vask & Clay-behandling",
      "Let polering (Glansoptimering)",
      "Premium Keramisk Coating (3 års holdbarhed)",
      "Rens af fælge & dækpleje",
      "Ruder pudset udvendigt",
    ],
    popular: false,
  },
  {
    name: "Varevogn",
    size: "Transporter / Boxer",
    examples: "VW Transporter, Ford Transit",
    price: "7.495",
    features: [
      "Grundig vask & Clay-behandling",
      "Let polering (Glansoptimering)",
      "Premium Keramisk Coating (3 års holdbarhed)",
      "Rens af fælge & dækpleje",
      "Ruder pudset udvendigt",
    ],
    popular: false,
  },
];

export const secondaryServices = [
  {
    slug: "keramisk-coating",
    title: "Keramisk Coating",
    description: "Den ultimative beskyttelse til din bils lak. Gør vasken lettere og beskytter mod ridser.",
    longDescription: "Vores keramiske coating er den mest avancerede lakbeskyttelse på markedet. Vi bruger kun de bedste produkter, som skaber en permanent kemisk binding til bilens lak. Dette resulterer i en ekstremt hård overflade, der er modstandsdygtig over for mikroridser, UV-stråler, kemikalier og fugleklatter.",
    features: [
      "Op til 5 års holdbarhed",
      "Ekstrem hydrofobisk effekt",
      "Spejlblank finish",
      "Beskytter mod UV og oxidation",
      "Letter den daglige rengøring"
    ],
    image: "https://assets.auxodev.dk/assets/c1d178a5-103b-4f78-8eea-c670ac502600/87ab909d-ac3a-4239-8cfc-4df9dd0f0668.jpg",
    secondaryImage: "https://assets.auxodev.dk/assets/c1d178a5-103b-4f78-8eea-c670ac502600/0a94d246-536f-45d6-85ac-66c67c0cc0d1.jpg",
  },
  {
    slug: "professionel-polering",
    title: "Professionel Polering",
    description: "Fjernelse af vaskeridser og hologrammer for at genskabe den perfekte finish.",
    longDescription: "Vores professionelle polering er designet til at fjerne ridser, hvirvelmærker og oxidering fra din bils lak. Vi bruger de nyeste teknikker og produkter for at sikre et fejlfrit resultat, der genskaber bilens dybde og glans.",
    features: [
      "Fler-trins polering",
      "Fjernelse af vaskeridser",
      "Genskabelse af glans",
      "Lakrensning",
      "Beskyttende forsegling"
    ],
    image: "https://assets.auxodev.dk/assets/c1d178a5-103b-4f78-8eea-c670ac502600/5d32df47-64b7-4d2f-aabc-29bb3a6d1d3a.jpg",
    secondaryImage: "https://assets.auxodev.dk/assets/c1d178a5-103b-4f78-8eea-c670ac502600/661e731e-d0ed-4dcb-a8e8-49cfac8ee4b6.jpg",
  },
  {
    slug: "indvendig-klargoring",
    title: "Indvendig Klargøring",
    description: "Grundig rengøring, støvsugning og pleje af alle overflader i kabinen.",
    longDescription: "Vi går i dybden med bilens interiør. Fra grundig støvsugning og damprensning af sæder til pleje af læder og plastoverflader. Vi sørger for, at din bil føles og dufter som ny indvendigt.",
    features: [
      "Dybdegående støvsugning",
      "Damprens af tekstiler",
      "Læderpleje og rens",
      "Rengøring af alle paneler",
      "Vinduespudsning indvendigt"
    ],
    image: "https://assets.auxodev.dk/assets/c1d178a5-103b-4f78-8eea-c670ac502600/8df445eb-9a25-414e-bfcf-8fa6358e4ec4.jpg",
    secondaryImage: "https://assets.auxodev.dk/assets/c1d178a5-103b-4f78-8eea-c670ac502600/0a7740d3-6af6-4ce8-8d69-a52fcbf7b4bb.jpg",
  },
  {
    slug: "luksus-haandvask",
    title: "Luksus Håndvask",
    description: "Skånsom vask i hånden med de bedste produkter på markedet.",
    longDescription: "En luksus håndvask hos os er langt mere end bare en vask. Vi benytter 2-spands metoden for at minimere risikoen for ridser, og vi bruger pH-neutrale produkter, der plejer bilens overflader.",
    features: [
      "Skånsom håndvask",
      "Fælge og hjulkasser renses",
      "Dørfalse rengøres",
      "Tørring med trykluft",
      "Dækglans påføres"
    ],
    image: "https://assets.auxodev.dk/assets/c1d178a5-103b-4f78-8eea-c670ac502600/80320cb1-feef-4044-af27-5c505010123a.jpg",
    secondaryImage: "https://assets.auxodev.dk/assets/c1d178a5-103b-4f78-8eea-c670ac502600/8f84f307-a95a-4df5-aa69-4c1c3e8703f5.jpg",
  },
];
